import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import {
  Grid, OutlinedInput, Typography,
} from '@mui/material';

import LabeledField from '../../../shared/components/LabeledField';
export default function ElectricityAssignmentDetails({ control, errors, requiredRule, isChanged }) {
  const { t } = useTranslation();
  if (!isChanged) return null;
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="caption" color="text.secondary">
          {t('office.assignment.changeHint')}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name="effective_from_fiscal_year"
          control={control}
          rules={{
            required: t('common.fieldRequired'),
            validate: value => (
              Number.isInteger(Number(value))
              && Number(value) >= 2000
              && Number(value) <= 2100
            ) || t('office.assignment.effectiveYearInvalid'),
          }}
          render={({ field }) => (
            <LabeledField
              label={t('office.assignment.effectiveFrom')}
              htmlFor="effective_from_fiscal_year"
              required
              error={errors.effective_from_fiscal_year?.message}
              helper={t('office.assignment.effectiveFromHint')}
            >
              <OutlinedInput
                {...field}
                id="effective_from_fiscal_year"
                size="small"
                type="number"
                inputProps={{ min: 2000, max: 2100, step: 1 }}
              />
            </LabeledField>
          )}
        />
      </Grid>

    </>
  );
}
